import React, {Fragment} from "react";

import {Button, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Select from "react-select";
import {faCirclePlus} from "@fortawesome/free-solid-svg-icons/faCirclePlus";

import ListTable from "../../../Common/ListTable";
import requestApi from "../../../services/requestApi.service";
import TemplateOperation from "./TemplateOperation";
import FormHeader from "../../../Common/FormHeader";
import { confirmBox, decodeHtmlEntities, showToast, getFormNameandLabel } from "../../../Common/Appcommon";

class Template extends React.Component{
    orgFormName = process.env.REACT_APP_ORGANIZATION_FORMNAME;
    constructor(props) {
        super(props);
        let defaultValue = { label: "All", value: "All" };
        this.state = {
            isMainModal: false,
            isSubModal: false,
            formList: [defaultValue],
            selectedForm : [],
            templates : [],
            formData : [],
            fields : [],
            formid : "",
            type: props.type,
            FILTEROPTION : {formsearch : defaultValue},
            isLoading:true,
        }
    }

    componentDidMount = async () => {
        await this.getFormNameByMobileNo();
        await this.loadFormData();
    }


    loadFormData = async () => {
        let {type, FILTEROPTION} = this.state;
        let params = {
            "ENTITY" : "TEMPLATEHELPER",
            "OPERATION" : "GET_CRM_TEMPLATES",
            "FORMNAME" : "",
            "METHOD" : "GETALL",
            "MODULENAME" : "",
            "FILTEROPTION" : JSON.stringify(FILTEROPTION),
            "channel" : type === "email" ? "EMAIL" : "SMS",
        };
        let response = await requestApi.processServerRequest(params, "Mobile");
        if(response.issuccess){
            let data = response.data;
            this.setState({
                fields : data[0] !== undefined  ? data[0] : [],
                formData : data[1] !== undefined ? data[1] : [],
                isLoading : false
            })
        }
    }

    getFormNameByMobileNo = async () => {
        let isEnabledList = {
            "isAddonEnabled": true,
            "isWsappEnabled": false,
            "isProfileEnabled": true,
            "isContactRef": false,
            "isMenuEnabledOnly" : true,
        };
        let response = await getFormNameandLabel(isEnabledList);

        if(response.issuccess){
            let data = response.data;
            this.setState(prevState => ({
                formList: [...prevState.formList, ...data]
            }));
        }
    }

    toggleMainMadal = () => {
        let {isMainModal} = this.state;
        if(isMainModal){
            this.setState({
                isMainModal : !isMainModal,
                formid: "",
                selectedForm: []
            })
        }else{
            this.setState({
                isMainModal : !isMainModal,
            })
        }
    }

    toggleSubMadal = () => {
        let {isSubModal} = this.state;
        this.setState({
            isSubModal : !isSubModal,
        })
        this.subModelContainer();
    }

    handleSearch = (name, value) => {
        let { FILTEROPTION } = this.state;
        FILTEROPTION[name] = value;
        this.setState({FILTEROPTION},async ()=>{
            await this.loadFormData();
        })
    }

    handleChange = async (name, selectedOption, isMultiple) => {
        let { FILTEROPTION } = this.state;
        FILTEROPTION[name] = selectedOption;
        this.setState({ FILTEROPTION },async ()=>{
            await this.loadFormData(true);
        });
    }

    createNewTemplate = (e) => {
        let {isMainModal} = this.state;
        this.setState({
            isMainModal : !isMainModal,
            isSubModal : false,
        })
        this.toggleMainMadal();
    }

    handleSelectChange = (e) => {
        this.setState({
            selectedForm : e
        })
    }

    initiateEditTemplate = async(e, formid) => {
        this.setState({
            formid: formid,
        })
        this.toggleMainMadal();
    }

    deleteCallBack = async () => {
        await this.loadFormData();
    }

    cloneOperation = async (data) => {
        let {type} = this.state;
        let isClone = await confirmBox("Clone Template", "Do you want to clone this template?");
        if(isClone){
            let params = {
                "ENTITY": type == "sms" ? "SMSTEMPLATE_ENTITYNAME" : "EMAILTEMPLATE_ENTITYNAME",
                "FORMTYPE": type == "sms" ? "SMSTEMPLATE_ENTITYNAME" : "EMAILTEMPLATE_ENTITYNAME",
                "OPERATION": "SAVE",
                "FORMNAME": data['formname'],
                "name" : data['name'],
                "desc" : data['name'],
                "access" : "1",
                "attachformdata" : "0",
                "address" : "###",
                "isdefault" : "0",
            };

            if(type === "sms"){
                params['type'] = 'Regular';
                params["t_id"] = data['t_id'];
                params["channel"] = "SMS";
                params["imageurl"] = data['imageurl'];
                params["content"] = data["content"];
            }else if(type === "email"){
                params['attachformdata'] = "0";
                params['address'] = "###";
                params['isdefault'] = "0";
                params['subject'] = data["subject"];
                params["content"] = decodeHtmlEntities(data['content']);
            }

            let response = await requestApi.processServerRequest(params, "WebV2", "get");
            if(response.issuccess){
                await this.loadFormData();
                showToast("Cloned Success");
            }
        }
    };

    handleSwitchChange = async (status, id) => {
        let {type} = this.state;
        let params = {
            "ENTITY" : "TEMPLATEHELPER",
            "OPERATION" : "UPDATE_ACCESS",
            "formid" : id,
            "access" : status,
            "channel" : type === "email" ? "EMAIL" : "SMS",
        }
        let response = await requestApi.processServerRequest(params, "WebV2", "get");
        if(response.issuccess){
            await this.loadFormData();
            showToast("Update Success...");
        }else{
            showToast("Update Failed...", "top-right" , "error");
        }
    }

    subModelContainer = () => {
        let {formList, isSubModal, selectedForm } = this.state;
        const updatedItems = formList.filter((item, index) => index !== 0);
        return(
            <div>
                <Modal isOpen = {isSubModal} size={'md'} >
                    <form  onSubmit={e => {this.createNewTemplate(e)}}>
                        <ModalHeader toggle={this.toggleSubMadal}>
                            {"Create Template"}
                        </ModalHeader>
                        <ModalBody>
                            <div className={'group-header group-header-flex'}>
                                <span> Choose a Module </span>
                            </div>
                            <Select
                                id={`create_new_template`}
                                name={`create_new_template`}
                                onChange={(e) => {this.handleSelectChange(e)}}
                                value={selectedForm}
                                options={updatedItems}
                                className={`basic-multi-select `}
                                classNamePrefix="wa-select"
                                required={true}
                            />
                        </ModalBody>
                        <ModalFooter>
                            <Button className={`le-button lePrimaryBtn br-4`} onClick={e => {this.toggleSubMadal()}}>
                                {"Cancel"}
                            </Button>
                            <Button className={`le-button lePrimaryBtn br-4`} color="primary" type={'submit'}>
                                {"Next"}
                            </Button>
                        </ModalFooter>
                    </form>
                </Modal>
            </div>
        )
    }


    renderElements =  (name,formData,fields,childprops,childstate) => {

        if(name === "subject"){
            let message = formData['subject'];
            return (
                <>
                    <div className={`d-grid text-left`}>
                        <span className={'text-left'}>{message}</span>
                    </div>
                </>
            )
        }else if(name === 'msgGroup'){
            let message = formData['content'];
            return (
                <>
                    <div className={`d-grid text-left`}>
                        <span className={'text-left'}>{message}</span>
                    </div>
                </>
            )
        }else if (name === "nameInfo"){
            let fieldvalue = formData['name'];
            return (
                <>
                    <div className={`d-grid text-left`}>
                        <span className={'template-primary'}>{fieldvalue}</span>
                    </div>
                </>
            )
        }
    }

    render(){
        let {isMainModal, isSubModal, formData, fields, formid, selectedForm, formList, type, isLoading} = this.state;
        let headerTitle = type === "email" ? "Email Template" : "SMS Template";
        let customRowConfig = {
            link : {
                onClick : this.initiateEditTemplate,
                condition : "",
                class : "row-link"
            }
        }
        let headerFieldConfig = []
        let customFieldConfig = [];
        if(type === "email"){
            headerFieldConfig["Name"] = {
                "class" : "w-2 text-left",
            };
            headerFieldConfig["Subject"] = {
                "class" : "text-left"
            };
            customFieldConfig["name"] = {
                "class" : "w-2 text-left template-message",
            };
            customFieldConfig["subject"] = {
                "class": "template-message",
                "decodeWithParse" : true,
                "render" : "subject"
            };
        }else if(type === "sms"){
            headerFieldConfig["Name"] = {
                "class" : "w-2 text-left ",
            };
            headerFieldConfig["Message"] = {
                "class" : "text-left"
            };
            customFieldConfig["name"] = {
                "class" : "w-2 text-left template-message",
                "render" : "nameInfo"
            };
            customFieldConfig["content"] = {
                "class": "template-message",
                "decodeWithParse" : true,
                "render" : "msgGroup"
            };
        }
        let buttonOptions = [
            {
                name : 'new_template',
                label : 'New Template',
                icon : faCirclePlus
            },
        ];

        let switchOptions =  {
            isSwitchNeeded : true,
            header : "Public",
            fieldid : "id",
            fieldvalue : "access",
            checkedValue : "1",
            handleSwitchChange : this.handleSwitchChange,
            name : "access",
            changeOnlyOwner : true,
        };

        let selectOptions = [
            {
                'name' : 'formsearch',
                'options' : formList,
                'multiple' : false,
                'defaultvalue' : 0
            }
        ];
        let searchOptions = [
            {
                name : 'name',
                placeHolder : 'Search by Name'
            }
        ];
        if(formList.length === 0) return;

        return(
            <Fragment>
                <div className="listview-container templates-listview kv-main-wrapper h100per">
                    <FormHeader
                        selectOptions={selectOptions}
                        searchOptions={searchOptions}
                        buttonOptions={buttonOptions}
                        handleSelectChange={this.handleChange}
                        handleSearch={this.handleSearch}
                        handleBtnClick={this.toggleSubMadal}
                    />
                    <div className={'p-2 mb-6'}>
                        <ListTable
                            key={Math.random()}
                            formData={formData}
                            fields={fields}
                            showRowCount={true}
                            customRowConfig={customRowConfig}
                            config={customFieldConfig}
                            renderElements={this.renderElements}
                            formName={type === "email" ? "emailtemplate" : "smstemplate"}
                            isDeleteNeeded={true}
                            pagination={false}
                            isOnlyOwnerDelete={true}
                            viewNeeded={false}
                            noDataMsg={`Templates not found`}
                            prefix={'templates'}
                            customClass={'no-border-table'}
                            headerConfig={headerFieldConfig}
                            isTableForm={false}
                            deleteCallBack={this.deleteCallBack}
                            isCloneNeeded={true}
                            cloneOperation={this.cloneOperation}
                            switchOptions={switchOptions}
                        />
                        {
                            isMainModal && !isSubModal && 
                            <TemplateOperation 
                                isMainModal = {isMainModal}
                                toggleMainMadal = {this.toggleMainMadal}
                                toggleSubMadal = {this.toggleSubMadal}
                                saveTemplate = {this.saveTemplate}
                                selectedForm = {selectedForm}
                                type = {type}
                                formid = {formid}
                                loadData = {this.loadFormData}
                                formList = {formList}
                                orgFormName = {this.orgFormName}
                            />}
                        {
                            isSubModal && !isMainModal && this.subModelContainer()
                        }
                    </div>
                </div>
            </Fragment>
        )
    }
}
export default Template;